import React, { useState } from "react";
import Navigation from "../../Components/Navigation/Navigation";
import BackArrow from "../../Components/BackArrow/BackArrow";
import Search from "../../Components/Search/Search";
import modalImg from "../../Assets/Images/toy.png";
import SearchBarResults from "../../Components/Search/SearchBarResults";
import ToysTable from "../../Components/Table/ToysTable";
import CreateModal from "../../Components/Modals/CreateToy";
import { ToastContainer, toast } from "react-toastify";

const Toys = () => {
  // modal
  const [modalShow, setModalShow] = useState(false);
  // search
  const [search, setSearch] = useState("");
  return (
    <>
         
    <div>
      <Navigation />
      <div className="toys-Main">
        <BackArrow to="/personality" />
        <div className="toys-Div">
          <h3>Toys</h3>
          <div className="search-modal">
            <Search SearchValFuc={setSearch} SearchValue={search} />
            <button
              className="create"
              variant="primary"
              onClick={() => {
                setModalShow(true);
              }}
            >
              + ADD TOYS
            </button>
          </div>
          <SearchBarResults SearchValue={search} />
        </div>
        <ToysTable SearchValue={search} />
      </div>
      <CreateModal
        show={modalShow}
        onHide={() => {
          setModalShow(false);
        }}
        head="Add a new toy"
        detail="You can add the new toy here"
        placeholder="Enter toy"
        images={modalImg}
      />
    </div>
    </>
  );
};

export default Toys;
